import { Reviewer } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAssignedCountryNominationReviewer: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  nominationId: number,
  accessToken?: string,
) => Promise<Reviewer> = (fetchContext, programId, countryId, nominationId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/nominations/${nominationId}/reviewer`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<Reviewer>(
  fetchContext.errorStore,
  response,
  'get assigned country nomination reviewer',
));
